/* eslint-disable camelcase */
const CONSTANTS = {
  product_form_selector: '[data-product-form-pdp]',
  product_option_select_selector: '[data-option-select]',
  product_main_image_selector: '[data-main-product-image]',
  product_variant_id_form_field: '[data-product-form] [name="id"]',
  product_image_thumbs_selector: '[data-product-thumbnail-index]',
  product_image_thumbs_attr: 'data-product-thumbnail-index',
  product_thumbnail_active_class: 'active',
  product_stock_wrapper_attr: 'data-product-in-stock',
  product_oos_text_attr: 'data-oos-text',
  product_in_stock_text_attr: 'data-in-stock-text',
  product_pre_order_attr: 'data-preOrder-text',
  product_unavailable_text_attr: 'data-unavailable-text',
  product_stock_map: 'data-product-stock-map',
  product_form_submit_button_selector: '[data-product-form-submit]',
  product_price_selector: '[data-product-price]',
  product_compare_at_price_selector: '[data-product-compare-at-price]',
  IMAGE_SIZE: '1000x1000',

}

export default CONSTANTS;